import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import httpMethod from 'services/update2025/httpMethod';

import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { Editor } from "primereact/editor";
import { ProgressSpinner } from "primereact/progressspinner";

import { TemplateContext } from "components/template/TemplateContext";
import { createTemplate, updateTemplate, validateTemplate } from "services/TemplateService";
import { handleError } from "utils/handleError";
import { actionUpdate, actionView } from "utils/action";

export const TemplateEditor = () => {
    const toast = useRef(null);
    const { t, i18n } = useTranslation(["template", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const templateContext = useContext(TemplateContext);
    const { template, resetTemplate, setTemplate, templates, setTemplates, submitted, setSubmitted, templateDialog, setTemplateDialog } = templateContext;

    const [showSpinner, setShowSpinner] = useState(false);
    const [titleEditor, setTitleEditor] = useState(t("template.titleCreateDetail"));

    useEffect(() => {
        // create
        if (!template?.id) {
            setTitleEditor(t("template.titleCreateDetail"));
        } else {
            // update
            if (actionUpdate === template.action) {
                setTitleEditor(t("template.titleUpdateDetail"));
            }
            // view
            else {
                setTitleEditor(t("template.titleDetail"));
            }
        }
    });

    const templateTypes = [
        { label: t("sms"), value: "SMS" },
        { label: t("notification"), value: "NOTIFICATION" },
        { label: t("email"), value: "EMAIL" },
    ];

    const onInputChange = (e, name) => {
        let _template = { ...template };
        const val = name === "content" && _template.type === "SMS" ? e.textValue.replace("\n", "") : e.target?.value || e.value || e.htmlValue || "";
        _template[`${name}`] = name === "code" ? val.toUpperCase() : val;

        setTemplate(_template);
    };

    const onChangeLoaiMauBc = (e) => {
        let _template = { ...template };
        _template.type = e.value;
        setTemplate({ ..._template });
    };

    const onEnabledChange = (e) => {
        let _template = { ...template };
        _template["enabled"] = e.checked;
        setTemplate(_template);
    };

    const hideDialog = () => {
        setSubmitted(false);
        setTemplateDialog(false);
    };

    const saveTemplateAction = () => {
        setShowSpinner(true);
        validateTemplate(template)
            .then(() => {
                if (!template.id) {
                    // Create
                    return createTemplate(headers, template).then((res) => {
                        toast.current.show({ severity: "success", summary: t("success", { ns: "common" }), detail: t("inform.created", { ns: "common", object: t("template") }), life: 3000 });
                        setTemplateDialog(false);
                        setSubmitted(true);
                        // resetTemplate();
                    });
                }
                // Update
                else {
                    return updateTemplate(headers, template.id, {
                        code: template.code,
                        content: template.content,
                        description: template.description,
                        enabled: template.enabled,
                        name: template.name,
                        // stt: template.stt,
                        title: template.title,
                        type: template.type,
                    }).then((res) => {
                        toast.current.show({ severity: "success", summary: t("success", { ns: "common" }), detail: t("inform.updated", { ns: "common", object: t("template") }), life: 3000 });
                        setTemplateDialog(false);
                        setSubmitted(true);
                        // resetTemplate();
                    });
                }
            })
            .catch((error) => handleError(toast, t, error))
            .finally(() => {
                setShowSpinner(false);
            });
    };

    const findIndexById = (id) => {
        let index = -1;
        for (let i = 0; i < templates.length; i++) {
            if (templates[i].id === id) {
                index = i;
                break;
            }
        }

        return index;
    };

    const checkView = () => {
        return actionView === template?.action;
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog visible={templateDialog} style={{ width: "70%" }} header={titleEditor?.toUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
                <div className="formgrid">
                    <div className="grid text-left">
                        <div className="col-12">
                            <div className="grid">
                                {/* mã */}
                                <div className="field col-12 md:col-6">
                                    <label htmlFor="code">
                                        {t("code")}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <InputText id="code" value={template?.code} keyfilter={/[^\s]/} maxLength={100} onChange={(e) => onInputChange(e, "code")} required autoFocus readOnly={template?.id} className={classNames({ "p-invalid": submitted && !template?.code })} />
                                    {submitted && !template?.code && <small className="text-danger">{t("code.required")}.</small>}
                                </div>

                                {/* loại bản mẫu */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="type">{t("type")}</label> <span className="text-danger">*</span>
                                    <Dropdown id="type" value={template?.type} options={templateTypes} required={true} onChange={(e) => onChangeLoaiMauBc(e)} disabled={checkView()} className={classNames({ "p-invalid": submitted && !template?.type })} />
                                    {submitted && !template?.type && <small className="text-danger">{t("type.required")}.</small>}
                                </div>

                                {/* hiệu lực */}
                                <div className="field col-12 md:col-3" style={{ display: "flex", justifyContent: "center", margin: "auto" }}>
                                    <label htmlFor="enabled">{t("enabled")}</label>
                                    <Checkbox id="enabled" checked={template?.enabled} onChange={onEnabledChange} disabled={checkView()} />
                                </div>
                            </div>

                            <div className="grid">
                                <div className="col-12 md:col-9">
                                    <div className="grid">
                                        {/* tên bản mẫu */}
                                        <div className="field col-12">
                                            <label htmlFor="name">
                                                {t("name")}
                                                <span className="text-danger">*</span>
                                            </label>
                                            <InputText id="name" value={template?.name} maxLength={255} onChange={(e) => onInputChange(e, "name")} required className={classNames({ "p-invalid": submitted && !template?.name })} readOnly={checkView()} />
                                            {submitted && !template?.name && <small className="text-danger">{t("name.required")}.</small>}
                                        </div>

                                        {/* tiêu đề */}
                                        <div className="field col-12">
                                            <label htmlFor="title">
                                                {t("title")}
                                                <span className="text-danger">*</span>
                                            </label>
                                            <InputText id="title" value={template?.title} maxLength={255} onChange={(e) => onInputChange(e, "title")} required className={classNames({ "p-invalid": submitted && !template?.title })} readOnly={checkView()} />
                                            {submitted && !template?.title && <small className="text-danger">{t("title.required")}.</small>}
                                        </div>
                                    </div>
                                </div>

                                {/* mô tả */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="description">{t("description")}</label>
                                    <InputTextarea id="description" value={template?.description || ""} maxLength={500} onChange={(e) => onInputChange(e, "description")} rows={6} cols={20} readOnly={checkView()} />
                                </div>
                            </div>

                            <div className="grid">
                                {/* nội dung */}
                                <div className="field col-12">
                                    <label htmlFor="content">
                                        {t("content")}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <Editor id="content" style={{ height: "200px" }} value={template?.content} maxLength={1000} onTextChange={(e) => onInputChange(e, "content")} required className={classNames({ "p-invalid": submitted && !template?.content })} readOnly={checkView()} />
                                    {submitted && !template?.content && <small className="text-danger">{t("content.required")}.</small>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="grid">
                    <div className="col-12">
                        {/* save */}
                        {!checkView() && (
                            <Button
                                style={{
                                    width: "max-content",
                                }}
                                className="mr-2"
                                label={t("save", { ns: "common" })}
                                icon="pi pi-check"
                                onClick={saveTemplateAction}
                            />
                        )}
                        {/* close */}
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            className="mr-2 p-button-danger"
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog visible={showSpinner} closable={false} resizable={false} draggable={false} showHeader={false}>
                <ProgressSpinner />
            </Dialog>
        </>
    );
};
